import { render, staticRenderFns } from "./ShopBrands.vue?vue&type=template&id=8c6e32a6&scoped=true"
import script from "./ShopBrands.vue?vue&type=script&lang=js"
export * from "./ShopBrands.vue?vue&type=script&lang=js"
import style0 from "./ShopBrands.vue?vue&type=style&index=0&id=8c6e32a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6e32a6",
  null
  
)

export default component.exports